import { FabProps } from "@mui/material";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setCookie, getCookie, deleteCookie } from "cookies-next";
import Router from "next/router";

export const getMyInformation = createAsyncThunk(
  "myinformation/get",
  async (keyword?: string): Promise<any> => {
    const url = process.env.NEXT_PUBLIC_BASE_URL_API;
    const response = await axios.get(`${url}/my-information`, {
      headers: {
        "access-token-front": `Bearer ${getCookie("access-token-front")}`,
      },
    });
    return response.data.data;
  }
);
